@import "tailwindcss";

@custom-variant dark (&:where(.dark, .dark *));

@theme {
  /* Primary: blues (from ideal-postcodes.co.uk main) */
  --color-brand-50: #f8f9ff;
  --color-brand-100: #e8efff;
  --color-brand-200: #c7d9ff;
  --color-brand-300: #9edafc;
  --color-brand-400: #6997d3;
  --color-brand-500: #3391ff;
  --color-brand-600: #18467d;
  --color-brand-700: #274d7e;
  --color-brand-800: #05326d;
  --color-brand-900: #0a1f3d;

  /* Secondary: purples */
  --color-accent-50: #f5f3ff;
  --color-accent-100: #ede9fe;
  --color-accent-200: #ddd6fe;
  --color-accent-300: #c4b5fd;
  --color-accent-400: #7d71d8;
  --color-accent-500: #545ceb;
  --color-accent-600: #5d4bd8;
  --color-accent-700: #2a17b1;
  --color-accent-800: #392e85;
  --color-accent-900: #150873;

  /* Success: greens */
  --color-success-50: #f0fdfa;
  --color-success-100: #ccfbf1;
  --color-success-200: #99f6e4;
  --color-success-300: #5fd2b5;
  --color-success-400: #35d2ab;
  --color-success-500: #00a67c;
  --color-success-600: #1f7c65;
  --color-success-700: #006c51;
  --color-success-800: #115e59;
  --color-success-900: #134e4a;

  /* Complementary: oranges */
  --color-comp-50: #fffbeb;
  --color-comp-100: #fef3c7;
  --color-comp-200: #fde68a;
  --color-comp-300: #ffc973;
  --color-comp-400: #ffb640;
  --color-comp-500: #ff9e00;
  --color-comp-600: #bf8830;
  --color-comp-700: #a66600;
  --color-comp-800: #92400e;
  --color-comp-900: #78350f;

  /* Highlight: lime/yellow */
  --color-highlight-50: #fefce8;
  --color-highlight-100: #fef9c3;
  --color-highlight-200: #fef08a;
  --color-highlight-300: #e0f28a;
  --color-highlight-400: #cbd946;
  --color-highlight-500: #a3c739;
  --color-highlight-600: #84a62b;
  --color-highlight-700: #658121;
  --color-highlight-800: #4d6419;
  --color-highlight-900: #3f5314;

  /* Brand-themable channel (defaults to Ideal Postcodes purple/indigo) */
  --color-theme-primary-50: #f5f3ff;
  --color-theme-primary-100: #ede9fe;
  --color-theme-primary-200: #ddd6fe;
  --color-theme-primary-300: #c4b5fd;
  --color-theme-primary-400: #7d71d8;
  --color-theme-primary-500: #6366f1;
  --color-theme-primary-600: #545ceb;
  --color-theme-primary-700: #2a17b1;
  --color-theme-primary-800: #392e85;
  --color-theme-primary-900: #150873;

  /* Surfaces (legacy — close to Tailwind gray-700/800/900, retained until callers migrate) */
  --color-surface-700: #1f2937;
  --color-surface-800: #101827;
  --color-surface-900: #0b1220;

  --font-mono: ui-monospace, "JetBrains Mono", "Cascadia Code", "Fira Code",
    "Roboto Mono", Menlo, Monaco, "Courier New", monospace;
}

@layer base {
  :root {
    color-scheme: dark;
  }
  body {
    @apply bg-gray-900 text-gray-200;
  }
}

@layer components {
  .card {
    @apply bg-gray-800/80 backdrop-blur border border-white/10 rounded-xl shadow-lg;
  }
  .btn-primary {
    @apply inline-flex items-center justify-center px-4 py-2 rounded-lg bg-theme-primary-600 hover:bg-theme-primary-500 text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed;
  }
  .input {
    @apply w-full px-3 py-2 rounded-lg bg-gray-800 border border-white/10 text-gray-200 placeholder-gray-500 focus:outline-hidden focus:ring-2 focus:ring-theme-primary-500;
  }
  .label {
    @apply block text-sm font-semibold text-gray-200 mb-2;
  }
}

@layer utilities {
  .data-display {
    @apply font-mono text-sm tabular-nums tracking-tight;
  }
}
